// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3MUq3","overflowing":"ReadFullNote_overflowing__2HhX-"};